const PLUGIN_SETUP_URL_BASE = '/boost/plugin';
export const getPluginSetupUrl = (pluginId) => {
    return `${PLUGIN_SETUP_URL_BASE}/${pluginId}`;
};
